import Header from '../../../components/Header'

export default function Embaixador() {
  return (
    <>
        <Header/>
        Embaixador
    </>
  )
}